import Cookies from 'js-cookie';
import store from './store/index';
import { homePageSet } from './routerConfig';
import { getUserLoginInfo } from './utils/servers';
// import assignMenus from './router/routers';
import actions from './utils/actions';
import { orgUsertree } from './utils/dataProcessing';
export default async function bootstrap() {
	const token = Cookies.get('token');
	if (token) {
		return getUserLoginInfo().then(({ data }) => {
			localStorage.setItem('userInfo', JSON.stringify(data.userInfo) || {});
      actions.setGlobalState({ userInfo: data.userInfo });
      localStorage.setItem('myWorkplat', JSON.stringify(data.userWorkbenchList) || []);
			localStorage.setItem('homepage', JSON.stringify(data.homepage) || []);
			// assignMenus && data.userRoleFuncList[0]?.roleFuncList.push(assignMenus);
      // 插入首页
			data.userRoleFuncList.forEach((ele) => {
				ele.roleFuncList.unshift(homePageSet);
			});

			data && store.dispatch({ type: 'ADD_MENUS', info: data.userRoleFuncList || [] });
			data && store.dispatch({ type: 'ADD_SYSMENUS', info: data.userRoleFuncList || [] });
			data && store.dispatch({ type: 'ADD_USERINFO', info: data.userInfo || {} });
			//orgUserHandle 封装了一层 进行公司结构的处理
			// let userOrgsInfoList = data.userOrgsInfoList.map((item) => {
			// 	item['orgId'] = item.orgTypeCode;
			// 	item['orgName'] = item.orgTypeName;
			// 	item['selectable'] = false;
			// 	// if (item.orgInfoList && item.orgInfoList.length > 0) {
			// 	//   item.orgInfoList.forEach(element => {
			// 	//     element['orgTypeCode'] = item.orgTypeCode;
			// 	//          element['orgTypeName'] = item.orgTypeName;
			// 	//   });
			// 	// }
			// 	return item;
			// });
			data && store.dispatch({ type: 'ADD_USERORGS', info: orgUsertree(data.userOrgsInfoList) || [] });
		});
	}
}
